<script>

	import {timeUpdate} from './stores.js';

	import {socketReady} from './stores.js';

	

	import About from "./About.svelte";
	import CanvasView from "./CanvasView.svelte";
	import Snapshot from "./Snapshot.svelte";
	import Empty from "./Empty.svelte";



	let currentView = Empty;

	function switchTab(tabname){

		switch (tabname) {

			case "About":
				currentView = About;
				hideMain(true);
				break;

			case "Canvas":
				currentView = Empty;
				hideMain(false);
				// currentView = CanvasView;
				break;

			case "Snapshot":
				currentView = Snapshot;
				hideMain(true);
				break;
		
			default:
				currentView = About;
				hideMain(true);
				break;
		}
	}

	let hideMain;

</script>

<main>

	{#if $socketReady == true}
		
		<div class="topBar">
			<div class=" buttonHolder">
				<button class="main">drawboard.cafe</button>
				<button class="tabButton" on:click={()=>{switchTab("Canvas")}} id="canvasButton">Canvas</button>
				<button class="tabButton" on:click={()=>{switchTab("Snapshot")}}>Snapshot</button>
				<button class="tabButton" on:click={()=>{switchTab("About")}}>About</button>

				<button class="snapshotClock">{$timeUpdate}</button>
			</div>

		</div>

		<CanvasView bind:hideItself={hideMain}/>

		<svelte:component this={currentView}></svelte:component>

	{:else}

	<div class="contentBox">

		<h1>TRYING TO CONNECT...</h1>

		<p>If nothing is working, return here in some time. High chance there's just some maintence going on</p>
	
	</div>

	{/if}



	<noscript>
		<div class="contentBox">
			<h1>Javascript is needed to run this, sorry</h1>
		</div>
	</noscript>

</main>

<style>

	.topBar{
		background-color: rgb(209, 209, 209);
		overflow: hidden;
		color: #453b3c;
		border: 2px solid #928d7700;
		display: flex;
	}

	.topBar .main{
		height: 100%;
		margin: 0px;
		text-align: center;
		font-size: 17px;
		background-color: rgb(206 135 69);
    	color: rgb(255 255 255);
		cursor: default;
	}

	.buttonHolder{
		width: 100%;
	}


	.topBar button:focus{
		outline: 0 !important;
		border: none;
	}

	.topBar button{
		border: none;
		margin-right: 5px;
	}

	.topBar .tabButton{
		height: 100%;
		padding: 3px;
		margin: 0px;
		color: #303030;
		text-align: center;
		font-size: 17px;
		background-color: rgb(209, 209, 209);
	}

	.snapshotClock{
		cursor: default;
		float: right;
		margin: 0px;
	}

	.topBar .tabButton:hover{
		background-color: rgb(255, 255, 255);
		color: black;
		transition-duration: 0.3s;
		cursor: pointer;
	}


	@media (orientation: portrait) {
		#canvasButton{
			display: none;
		}
    }






</style>